import React from 'react';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

import Box from '@material-ui/core/Box';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { useState } from 'react';

export const Contact = props => {
  const {
    olokooAccessToken,
    integrationUUID,
    honeyPotFieldName,
    redirectSuccessURL,
    redirectErrorURL,
    interestedOptions,
    interestedInHeading,
    formInputs,
    submitButtonLabel
  } = props;

  const theme = useTheme();

  const useStyles = makeStyles(theme => ({
    logo: {
      width: 100,
    },
  }));

  var initialInputValues = {};
  if (formInputs && formInputs.length) {
    formInputs.forEach(input => {
      initialInputValues[input.name] = '';
    });
  }

  const [inputValues, setInputValues] = useState(initialInputValues);
  const [formReady, setFormReady] = useState(false);
  const [selectedInterested, setSelectedInterested] = useState([]);

  const handleInterestedChange = event => {
    const { name, id, value, checked } = event.target;
    if (!selectedInterested.includes(value)) {
      setSelectedInterested([...selectedInterested, value]);
    } else if (checked === false) {
      setSelectedInterested([...selectedInterested.filter(word => word !== value)]);
    }
  };

  const handleOnChange = event => {
    const { name, value } = event.target;
    setInputValues({ ...inputValues, [name]: value });
    
    const isFormReady = () => {
      var response = true;
      Object.keys(inputValues).forEach(function(key) {
          if (inputValues[key] === '') {
            response = false;
          }
      });
      return response;
    };

    setFormReady(isFormReady);
  };

  const classes = useStyles();

  return (
    <form action="https://api.olokoo.com/forms/submit" name="contact" method="post">
      <input type="hidden" name="honeypotfieldname" value={ honeyPotFieldName } />

      {redirectSuccessURL &&
        <input type="hidden" name="redirectsuccess" value={ redirectSuccessURL } />
      }
      {redirectErrorURL &&
        <input type="hidden" name="redirecterror" value={ redirectErrorURL } />
      }
      <input type="hidden" name="olokooaccesstoken" value={ olokooAccessToken } />
      <input type="hidden" name="olokoointegration" value={ integrationUUID } />

      <input type="hidden" name={ honeyPotFieldName } />

      {(interestedInHeading || interestedOptions) &&
        <Box className="interested-in-options-wrap">
          {interestedInHeading &&
            <Box className="interested-in-heading">{ interestedInHeading }</Box>
          }
          {interestedOptions &&
            <input type="hidden" name="interested" placeholder="Interested In" value={ selectedInterested && selectedInterested.join(', ') } />
          }
          {interestedOptions && interestedOptions.map((value, key) => (
            <Box className="interested-in-option-item" key={ key }>
              <input
                type="checkbox"
                className="option-checkbox"
                id={`optionCheckbox${key}`}
                value={ value.option }
                onChange={ handleInterestedChange } /> 
              <label htmlFor={`optionCheckbox${key}`}>{ value.option }</label> 
            </Box>
          ))}
        </Box>
      }
      <Box>
        {formInputs && formInputs.length && formInputs.map((value, key) => (
          <Box className="floating-label-input-group" key={ key }>
            <input
              required={ true }
              placeholder={ value.placeholder }
              type={ value.type }
              name={ value.name }
              id={ value.name }
              autoComplete="off"
              onChange={ handleOnChange } />
            <label htmlFor={ value.name }>
              { value.placeholder }
            </label>
          </Box>
        ))}
      </Box>
      <Box>
        <button typle="submit" disabled={ !formReady } className={`primary-button ${!formReady && 'disabled'}`}>{ submitButtonLabel }</button>
      </Box>
    </form>
  );
};
